module.exports = __webpack_public_path__ + "static/Q2_2025_Investor_call_(Dial_in_Information)-357c48c6fcd159a00aa00eb1889bd2f4.pdf";